'use client'

import { useRef } from 'react'
import SegmentedControl from 'ui/src/components/controls/segmented-control'

type Props = {
    /** Display labels, in the same order as `values`. */
    options: string[]
    /** Locale ids submitted for each option, in the same order as `options`. */
    values: string[]
    activeIndex: number
    /** Path to return to. Must be in the endpoint's allowlist. */
    returnPath: string
}

/**
 * Wraps the shared SegmentedControl so picking a language is a single click.
 *
 * Posts to /api/locale rather than using a Server Action. An action posts to
 * the current URL, which only works where Next serves the page — /settings is
 * served by Django and rejects it. One endpoint keeps both switchers working
 * regardless of who renders the page they sit on.
 */
const LocaleSegmentedControl = ({ options, values, activeIndex, returnPath }: Props) => {
    const localeInputRef = useRef<HTMLInputElement>(null)

    return (
        <form action="/api/locale" method="post" className="flex items-center">
            <input type="hidden" name="returnPath" value={returnPath} />
            <input ref={localeInputRef} type="hidden" name="locale" defaultValue={values[activeIndex]} />
            <SegmentedControl
                options={options}
                defaultIndex={activeIndex}
                size="small"
                gradient="blue-green"
                onChange={(index) => {
                    const localeInput = localeInputRef.current
                    const selected = values[index]

                    if (!localeInput || !selected) {
                        return
                    }

                    localeInput.value = selected
                    localeInput.form?.requestSubmit()
                }}
            />
        </form>
    )
}

export default LocaleSegmentedControl
